// @ts-strict-ignore
import { RudderAnalytics } from "@rudderstack/analytics-js";
import { useEffect, useState } from "react";

const useRudderStackAnalytics = (enabled: boolean): RudderAnalytics | undefined => {
  const [analytics, setAnalytics] = useState<RudderAnalytics>();

  useEffect(() => {
    if (!enabled || analytics) {
      return;
    }
    const analyticsInstance = new RudderAnalytics();
    setAnalytics(analyticsInstance);
  }, [analytics]);

  return analytics;
};

export { useRudderStackAnalytics };
